export enum ValidationRule {
  MENU_NO_EMPTY_SECTIONS = 'menu_no_empty_sections',
  MENU_DESCRIPTION = 'menu_description',
  ITEM_DESCRIPTION = 'item_description',
  ITEM_POS_ID = 'item_pos_id',
  ITEM_DEFAULT_PRICE = 'item_default_price',
  ITEM_TAX_RATE = 'item_tax_rate',
  ITEM_BUNDLE_MIN_ONE_OPTION_GROUP = 'item_bundle_min_one_option_group',
  ITEM_OPTION_GROUP_MIN_ONE_OPTION = 'item_option_group_min_one_option',
}

export interface IValidateCriteria {
  price_scheme_id?: string;
  schedule_id?: string;
  timetable_id?: string;
  menu_id?: string;
  menu_set_id?: string;
  rules: ValidationRule[];
  excluded_items?: string[];
}

// Either supply criteria for a new validation run, or prev_report_id to
// re-run the same criteria as an earlier report.
export interface IValidateRequestBody {
  criteria?: IValidateCriteria;
  prev_report_id?: string;
}

export interface IValidateResponseBody {
  report_id: string;
}
